<template>
  <div class="navbar navbar-default navbar-fixed-top">
    <div class="navbar-header">
      <a class="navbar-brand" href="/"><img src="/static/dist/images/GR-new+.png"></a>
      <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navbar-main">
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
    </div>
    <div class="collapse navbar-collapse" id="navbar-main">
      <ul class="nav navbar-top-links navbar-right">
        <li>
          <router-link to="/">Welcome</router-link>
        </li>
        <li>
          <router-link to="/about">How it works</router-link>
        </li>
        <li>
          <router-link to="/">Services</router-link>
        </li>
        <li>
          <router-link to="/community">Community</router-link>
        </li>
        <li>
          <router-link to="/contact">Contact</router-link>
        </li>
        <li>
          <router-link to="/contribute" class="btn-green">Contribute</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
}
</script>



// WEBPACK FOOTER //
// src/components/Headers/index.vue